import { Autocomplete } from "@/components/atoms";
import { useFilterCompanies, useFilterJobs } from "@/providers/contexts";
import { AutocompleteOption } from "@/components/atoms/Autocomplete";
import {
  JobPostFilterOptions,
  useCompanyFilterOptions,
  useJobPostFilterOptions,
} from "@/hooks";
import { Company } from "@/types/company";
import { FilterPanelProps } from "../FilterPanel";

export interface CompanyFilterProps {
  page: FilterPanelProps["page"];
}

export const CompanyFilter = ({ page }: CompanyFilterProps) => {
  const { filters: jobPostFilters } = useJobPostFilterOptions();
  const { companies: companyCompanies } = useCompanyFilterOptions();

  const {
    filters: jobFilters,
    dispatch: jobDispatch,
    loading: jobLoading,
  } = useFilterJobs();
  const {
    filters: companyFilters,
    dispatch: companyDispatch,
    loading: companyLoading,
  } = useFilterCompanies();

  const isSearchPage = page === "search";
  const companies = isSearchPage
    ? jobPostFilters?.companies || []
    : companyCompanies;
  const { selectedCompanies } = isSearchPage ? jobFilters : companyFilters;
  const dispatch = isSearchPage ? jobDispatch : companyDispatch;

  const loading = jobLoading || companyLoading;

  const selectedOptions = selectedCompanies.map(selected => {
    const company = companies.find(
      company => company.company_name === selected.company_name,
    );

    return {
      key: company?.id ?? "",
      value: company?.company_name ?? "",
    };
  });

  return (
    <Autocomplete
      multiple
      componentName={"company-filter"}
      inputLabel="Companies"
      options={companies.map(company => ({
        key: company.id,
        value: company.company_name,
      }))}
      value={selectedOptions}
      onChange={(_, value) => {
        const selectedValues = (value as AutocompleteOption[]).filter(Boolean);

        const selected: JobPostFilterOptions["companies"] = selectedValues
          .map(opt => companies.find(company => company.id === opt.key))
          .filter((company): company is Pick<Company, "id" | "company_name"> =>
            Boolean(company),
          );

        dispatch({
          type: "SET_FILTERS",
          payload: { selectedCompanies: selected },
        });
      }}
      loading={loading}
      autocompleteSx={{
        mt: 0,
      }}
    />
  );
};
